/**
 * @package  	Cavalree_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
    var $ = jQuery;
}

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
detectScrollbarWidth();
// END Vanilla JS

function scrollToHash(element) {
    $('html, body').animate({
        'scrollTop': $(element).offset().top
    }, 1000);
}

document.addEventListener('DOMContentLoaded', function () {
    var _hash = location.hash;

    if (_hash) {
        scrollToHash(document.querySelector(_hash));
    }
}, false);

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {
    $('.accordion').on("click", function(e){
        if ($(this).hasClass("is--active")) {
            $(this).removeClass("is--active");
        } else {
            $(".accordion.is--active").removeClass("is--active");
            $(this).addClass("is--active");
        }
    });

    if ( $('.page article.has-jump-links').length) {
        updateFixedJumpLinks();
    }
});

function updateFixedJumpLinks() {
    var _container = $('.site-main'),
        _offset = _container.offset(),
        _top = _offset.top,
        _bottom = ($(window).outerHeight() - _container.outerHeight()),
        _element = $('.block--jump-links');

    $('.site-main #content').css({
        'padding-bottom': _element.outerHeight()
    });

    $(window).scroll(function(){
        if ( ($(this).scrollTop() + _bottom - _element.outerHeight() + _top + 50) > 0 ) {
            _element.addClass('position-bottom');
        } else {
            _element.removeClass('position-bottom');
        }
    });
}

// END jQuery Ready
function detectScrollbarWidth() {
    /* Detect scrollbar width to properly center full- and wide-width elements */
    let root = document.documentElement;
    var outside = document.createElement("div");
    var inside = document.createElement("div");
    
    outside.style.width = inside.style.width = "100%";
    outside.style.overflow = "scroll";
    document.body.appendChild(outside).appendChild(inside);
    
    var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;
    
    outside.parentNode.removeChild(outside);
    root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function addHeadingNonBreakingSpace() {
    var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

    headings.forEach(function (head, index) {
        let str = head.textContent;
        let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
        let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

        firstSection = firstSection.trim();

        let newStr = firstSection + "\u00a0" + lastSection;

        head.innerHTML = newStr;
    });
}
